// prizewinnerContractConfig.js

// Import the ABI from a JSON file (assuming the ABI file is located in the 'abis' directory)
import prizewinnerContractABI from '../abi/prizewinnerContractABI.json';

// Define the contract address (replace '0x123...' with your contract's actual address)
export const prizewinnerContractAddress = '0x672efC722020af9a17E82d2c0F9D8898189B1774';

// Export the ABI
export const prizewinnerAbi = prizewinnerContractABI;